import { Component } from '@angular/core';

@Component({
    selector: 'internal-user',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class InternalUserComponent {}
